export default {
  'common.openDataLab': 'OpenDataLab',
  'common.formatted': '统一格式',
  'common.original': '原始格式',
  'common.finish': '完成',
  'common.submit': '提交',
  'common.confirm': '确认',
  'common.reset': '重置',
  'common.cancel': '取消',
  'common.totalItems': '共 {num} 条',
  'common.operate': '操作',
  'common.download': '下载',
  'common.other': '其他',
  'common.all': '全部',
  'common.all.xlab': '{num} 数据集',
  'common.delete': '删除',
  'common.top': '置顶',
  'common.filter': '筛选',
  'common.404': '抱歉，您访问的页面不存在。',
  'common.backHome': '回到首页',
  'common.edit': '编辑',
  'common.preview': '预览',
  'common.code': '代码',
  'common.clear': '清空',
  // v1.9.0
  'common.basic': '基本信息',
  'common.email': '邮箱',
  'common.phone': '手机号',
  'common.github': 'GitHub ID',
  'common.pw': '密码',
  'common.otherInfo': '其他信息',
  'common.username': '用户名',
  'common.org': '组织/公司',
  'common.weChat': '微信',
  'common.zhihu': '知乎账号名称',
  'common.save': '保存',
  'common.copy': '复制',
  'common.copySuccess': '复制成功',
  'common.prev': '上一页',
  'common.next': '下一页',
  'common.loadMore': '加载更多',
  'common.noData': '暂无数据',
  'common.enter': '请输入',
  'common.select': '请选择',
  'common.status': '状态',
  'common.know': '我知道了',
  'common.desc': '描述',
  'common.quit': '退出',
  'common.home.all': '全部 {num} 个数据集',
  'common.login': '登录',

  // 冰山之下的数据集；
  'common.iceberg': '探寻数据的 “冰山之下”',

  'common.type': '类型',
  'common.organization': '组织',
  'common.stayTuned': '敬请期待',

  'common.datasets.use.title': '免责申明',
  'common.datasets.use.law': '尊重原创，非授权批量搬运将承担法律责任。如有合作意向，请联系{slot}。',
  'common.online.explore': '在线体验',
  'common.local.deploy': '本地部署',

  'common.datasets.notFound': '数据集不存在',
  'common.datasets.notFound.try': '去试试其他数据集～',
  'common.datasets.notFound.back': '返回首页',
  'common.expand': '展开',
  'common.collapse': '收起',
  'common.upload.text': '上传中，请耐心等待',
  'common.submit.success': '提交成功',
    'common.mobile.noAccess': '暂不支持移动端，请使用网页端访问'
};
